import { render, staticRenderFns } from "./PermissionsRanking.vue?vue&type=template&id=6afea96e&scoped=true"
import script from "./PermissionsRanking.vue?vue&type=script&lang=js"
export * from "./PermissionsRanking.vue?vue&type=script&lang=js"
import style0 from "./PermissionsRanking.vue?vue&type=style&index=0&id=6afea96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afea96e",
  null
  
)

export default component.exports